import script from "./calculate.vue?vue&type=script&setup=true&lang=js"
export * from "./calculate.vue?vue&type=script&setup=true&lang=js"

import "./calculate.vue?vue&type=style&index=0&id=16c8e6e4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c8e6e4"]])

export default __exports__